export default {
  data () {
    return {
      class: 'h-map xl:h-auto',
      mapOptions: {}
    }
  },

  computed: {
    defaultMapOptions () {
      return {
        container: this.$refs.map,
        zoom: 13,
        theta: 55,
        phi: 5,
        lon: 6.1727,
        lat: 49.1191,
        sunPositionSelector: true,
        draggableTouch: true,
        scrollwheel: false
      }
    }
  },

  mounted () {
     kimono.addMap({
      ...this.defaultMapOptions,
      ...this.mapOptions
    })
    .on('load', this.onLoad)
  },

  render (createElement) {
    return createElement(
      'div',
      {
        ref: 'map',
        class: this.class
      }
    )
  }
}
